import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { usePageMeta } from "@/hooks/usePageMeta";
import { videos } from "@/mocks/videos";
import HeroCarousel from "./components/HeroCarousel";
import CategoryShortcuts from "./components/CategoryShortcuts";
import FeaturedGrid from "./components/FeaturedGrid";
import LatestGrid from "./components/LatestGrid";
import TopRanking from "./components/TopRanking";

export default function Home() {
  usePageMeta({
    title: "在线视频 - 海量视频资源在线观看平台",
    description:
      "在线视频网站为您提供丰富多样的视频内容，包括电影、电视剧、综艺和短视频，方便您随时在线观看和发现热门大片。",
    keywords:
      "在线视频,视频播放,在线观看,电影视频,电视剧视频,网络视频,高清视频,视频平台",
  });

  const featured = videos.filter((v) => v.featured);
  const latest = [...videos.filter((v) => v.isNew)].sort(
    (a, b) => b.playCount - a.playCount,
  );
  const hot = [...videos].sort((a, b) => b.playCount - a.playCount);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <h1 className="sr-only">在线视频 - 海量视频资源在线观看平台</h1>
        <HeroCarousel videos={featured.slice(0, 5)} />

        <div className="py-10 md:py-14 space-y-14 md:space-y-20">
          <CategoryShortcuts />
          <FeaturedGrid videos={featured} />
          <LatestGrid videos={latest} />
          <TopRanking videos={hot} />
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}